import React from "react";

export default function PriceListPage() {
  
  return (
    <React.Fragment>      

    <h2>Preisliste</h2>

    <object
      data="/Preisliste.pdf"
      type="application/pdf"
      style={{
        marginTop: '20px',
        width: '100%',
        height: '80vh'
      }}
    >
      <p>Unable to display PDF. <a href="/Preisliste.pdf">Download</a> instead.</p>
    </object>
  </React.Fragment>
  )
}